import React from 'react';
import PropTypes from 'prop-types';
import './Waves.css';

const Waves = (props) => {
  const { colors } = props;
  const mainBg = colors[0];
  const bg1 = colors[1];
  const bg2 = colors[2];

  return (
    
      <div className="waves-header" style={{background: `${mainBg}`}}>
        <div className="inner-header waves-flex"></div>

        <div>
          <svg
            className="waves"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shapeRendering="auto"
          >
            <defs>
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />
            </defs>
            <g className="parallax">
              <use
                xlinkHref="#gentle-wave"
                x="48"
                y="0"
                fill={bg1}
              />
              <use
                xlinkHref="#gentle-wave"
                x="48"
                y="3"
                fill="rgba(255,255,255,0.5"
              />
              <use
                xlinkHref="#gentle-wave"
                x="48"
                y="5"
                fill={bg2}
              />
              <use xlinkHref="#gentle-wave" x="48" y="7" fill={mainBg}/>
            </g>
          </svg>
        </div>
      </div>

      // <div className="waves-content waves-flex"></div>
    
  );
};

Waves.propTypes = {
  colors: PropTypes.array,
};

export default Waves;
